import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { CheckboxCompoment } from "../../../Components/CheckboxComponent";
import { WidgetNewestDocuments } from "../Widgets/WidgetNewestDOcuments";

export type PopupNewestDocumentsComponentProps = {
    widget: WidgetNewestDocuments;
}

export class PopupNewestDocumentsComponent extends JSXComponent {
    props: PopupNewestDocumentsComponentProps;
    title: LanguageStringComponent;
    fixedLayout: boolean;
    settingsName: string;
    noClickAction?: boolean;

    constructor(props: PopupNewestDocumentsComponentProps) {
        super(props);

        this.fixedLayout = this.props.widget.props.fixedLayout;
        this.settingsName = this.props.widget.props.settingsName;
    }

    onSave = (): boolean => {
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.props.fixedLayout = this.fixedLayout;
        this.props.widget.props.settingsName = this.settingsName;

        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;
    private getElement = () => {
        return <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetNewestDocuments}>

            {this.renderTitle()}

            <TextComponent model={this} field="settingsName" name="MSO Table SettingsName" />
            <CheckboxCompoment model={this} field="fixedLayout" label="Fixed Layout" />
        </DynPopup>;
    }

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        });
        return this.title.render();
    }

    render(): HTMLElement {
        this.element = this.getElement();
        return this.element;
    }
}
